import React from 'react'
import { Helmet } from 'react-helmet'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

const initialSchemaData = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: 'Mogileńska 50',
  image: 'https://www.mogilenska50.pl/static/bg-min-13d0f7580a2c141d4f406fe293eea9e7.jpg',
  '@id': '',
  priceRange: '',
  url: 'https://www.mogilenska50.pl/',
  description: 'Nieruchomość magazynowo-produkcyjna w sercu Poznania',
  disambiguatingDescription:
    'Nieruchomość znajduje się przy ulicy Mogileńskiej 50 w Poznaniu, we wschodniej części miasta, w okolicy Jeziora Malta. Magazyn jest oddalony zaledwie o 3 kilometry od obwodnicy Poznania i o 5 kilometrów od centrum miasta, co umożliwia dogodną komunikację dla pracowników i sprawny transport. Budynek oferuje około 17 000 mkw przestrzeni magazynowej i produkcyjnej oraz około 2 800 mkw powierzchni biurowej',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Poznań',
    addressRegion: 'Województwo wielkopolskie',
    postalCode: '61-044',
    streetAddress: 'Mogileńska 50',
    addressCountry: 'PL',
    telephone: '+48 509 657 324',
    email: 'tomasz.mirowski@cbre.com',
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '08:00',
    closes: '18:00',
  },
  sameAs: ['https://www.mogilenska50.pl/'],
}

const schemaData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Mogileńska 50',
  alternateName: 'Nieruchomość magazynowo-produkcyjna w sercu Poznania',
  url: 'https://www.mogilenska50.pl/',
  logo: 'https://www.mogilenska50.pl/static/bg-min-13d0f7580a2c141d4f406fe293eea9e7.jpg',
  sameAs: 'https://uk.linkedin.com/company/martley-capital-group/',
}

const SEO = ({ title, description, image, pathname, article }) => (
  <StaticQuery
    query={query}
    render={({
      site: {
        siteMetadata: { defaultTitle, titleTemplate, defaultDescription, siteUrl, defaultImage },
      },
    }) => {
      const seo = {
        title: title || defaultTitle,
        description: description || defaultDescription,
        image: `${siteUrl}${image || defaultImage}`,
        url: `${siteUrl}${pathname || '/'}`,
      }

      return (
        <>
          <Helmet title={seo.title} titleTemplate={titleTemplate}>
            <html lang="pl" />
            <title>{seo.title}</title>
            <meta name="theme-color" content="#000"></meta>
            <meta name="description" content={seo.description} />
            <meta name="image" content={seo.image} />
            {seo.url && <meta property="og:url" content={seo.url} />}
            {(article ? true : null) && <meta property="og:type" content="article" />}
            {seo.title && <meta property="og:title" content={seo.title} />}
            {seo.description && <meta property="og:description" content={seo.description} />}
            {seo.image && <meta property="og:image" content={seo.image} />}
            <meta name="twitter:card" content="summary_large_image" />
            {seo.title && <meta name="twitter:title" content={seo.title} />}
            {seo.description && <meta name="twitter:description" content={seo.description} />}
            {seo.image && <meta name="twitter:image" content={seo.image} />}
            <script type="application/ld+json">{JSON.stringify(initialSchemaData)}</script>
            <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
          </Helmet>
        </>
      )
    }}
  />
)
export default SEO
SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  pathname: PropTypes.string,
  article: PropTypes.bool,
}
SEO.defaultProps = {
  title: null,
  description: null,
  image: null,
  pathname: null,
  article: false,
}
const query = graphql`
  query SEO {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
      }
    }
  }
`
